export interface ICheckboxField {
  checked: boolean;
}

export class CheckboxField implements ICheckboxField {
  checked: boolean = false;

  constructor(configOverride?: Partial<ICheckboxField>) {
    if (configOverride) {
      Object.assign(this, configOverride);
    }
  }
}
